import React from 'react';
import { SmartDemoScheduler } from '@/components/scheduling/SmartDemoScheduler';

export default function ScheduleDemoPage() {
  return (
    <SmartDemoScheduler
      source="schedule_demo_page"
      onDemoScheduled={() => {
        console.log('Demo scheduled from dedicated page');
      }}
    />
  );
}
